import { Fragment, memo } from 'react'

import isEqual from 'react-fast-compare'
import {
  ResponsiveContainer,
  AreaChart as RechartsAreaChart,
  Area,
} from 'recharts'

import { AnalyticsResponse } from '@tribeplatform/gql-client/types'

import type { GroupBy, ChartTimeFrame } from '../types/index.js'
import {
  CHART_ANIMATION_ACTIVE,
  CHART_ANIMATION_DURATION,
  TinyChartColors,
} from '../utils/constants.js'
import { rechartsLineChartParser as rechartsAreaChartParser } from '../utils/parser.js'

interface Props {
  data: {
    chartData: AnalyticsResponse
    timeFrame: ChartTimeFrame
    indexBy: string[]
    groupBy?: GroupBy[]
    ColorTheme?: string[]
    id?: string
  }
}

export const TinyAreaChartRecharts = memo(
  ({
    data: {
      chartData,
      timeFrame,
      indexBy,
      groupBy,
      ColorTheme = TinyChartColors,
      id,
    },
  }: Props) => {
    return (
      <ResponsiveContainer width="99%" height={50}>
        <RechartsAreaChart
          data={rechartsAreaChartParser(chartData, indexBy, timeFrame, groupBy)}
          margin={{ top: 1, left: 0, right: 0, bottom: 1 }}
        >
          {indexBy.map((label, index) => (
            <Fragment key={label}>
              <defs>
                <linearGradient
                  id={`tinyAreaGradient${label.replace(/\s/g, '')}${index}${
                    id || ''
                  }`}
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop
                    offset="5%"
                    stopColor={ColorTheme[index]}
                    stopOpacity={0.8}
                  />
                  <stop
                    offset="95%"
                    stopColor={ColorTheme[index]}
                    stopOpacity={0}
                  />
                </linearGradient>
              </defs>
              <Area
                type="monotone"
                dataKey={label}
                stroke={ColorTheme[index]}
                strokeWidth={2}
                fillOpacity={0.5}
                fill={`url(#tinyAreaGradient${label.replace(
                  /\s/g,
                  '',
                )}${index}${id || ''})`}
                isAnimationActive={CHART_ANIMATION_ACTIVE}
                animationDuration={CHART_ANIMATION_DURATION}
              />
            </Fragment>
          ))}
        </RechartsAreaChart>
      </ResponsiveContainer>
    )
  },
  isEqual,
)
